import firebase from "firebase/compat/app";
import "firebase/compat/database";

export interface ICharityMmsSetup {
  mmsSenderAreaCode: string;
  phoneNumberMethod?: 'newNumber' | 'portNumber';
  status?: 'pending' | 'completed';
  configuredAt?: number;
  estimatedDays?: number;
  losingCarrier?: string;
  portType?: string;
  useSharedTcr?: boolean;
  sharedTcr?: {
    entryId: string;
    label: string;
  };
  bandwidth?: {
    phoneNumber?: string;
    locationId?: string;
    applicationId?: string;
    smsEnabled?: boolean;
    mmsEnabled?: boolean;
    locationAssigned?: boolean;
  };
  error?: {
    message: string;
    timestamp: number;
  };
}

export const resetMmsSetup = async (charityId: string): Promise<void> => {
  if (!charityId) {
    throw new Error("Charity ID is required");
  }
  const database = firebase.database();
  await database.ref(`${charityId}/charitySetup/mms/error`).remove();
  await database.ref(`${charityId}/charitySetup/mms/status`).remove();
  await database.ref(`${charityId}/charitySetup/mms/mmsSenderAreaCode`).remove();
  await database.ref(`${charityId}/charitySetup/mms/useSharedTcr`).remove();
  await database.ref(`${charityId}/charitySetup/mms/sharedTcr`).remove();
};

export const saveMmsSetupData = async (
  charityId: string,
  data: Partial<ICharityMmsSetup>
): Promise<void> => {
  if (!charityId) {
    throw new Error("Charity ID is required");
  }

  const database = firebase.database();
  const mmsSetupRef = database.ref(`${charityId}/charitySetup/mms`);

  const snapshot = await mmsSetupRef.once('value');
  const existingData = snapshot.val() || {};

  const updatedData: Partial<ICharityMmsSetup> = {
    ...existingData,
    ...data,
  };

  await mmsSetupRef.set(updatedData);
};

export const loadMmsSetupData = async (
  charityId: string
): Promise<ICharityMmsSetup | null> => {
  if (!charityId) {
    throw new Error("Charity ID is required");
  }

  const database = firebase.database();
  const mmsSetupRef = database.ref(`${charityId}/charitySetup/mms`);

  const snapshot = await mmsSetupRef.once('value');
  return snapshot.val() || null;
};
